
import { Product } from "@/types/product";

export const touchPanelProducts: Product[] = [
  {
    id: "rxt-4-wm",
    groupId: "reax-touch-controllers",
    name: "RXT-4-WM",
    description: "About\nThe RXT-4 is the world's first 4\" ReAX™ JavaScript based Touch Panel/Control System. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-4 has a beautiful 480 x 480 1:1 aspect ratio touch screen with 160° viewing and room status lighting in just about any color combination. It is designed to mount in a 2 Gang or European style electrical box. The 2D/3D graphics engine with 1080p H.264 streaming decoder provides a powerful solution for complex graphics and video, ensuring an enhanced user experience.\n\nTo further enhance the experience, the RXT-4 has a 1-watt speaker, stereo digital microphone, proximity sensor, & ambient light sensor. The internal web server allows control from remote device like cell phones and computers. The RXT-4 is a powerful 'all-in-one' solution for your presentation and automation needs.\n\nCore Studio tool is available free of charge for code and interface creation.",
    features: [
      "4\" 480x480 Resolution",
      "420 nits",
      "Dual Core Processor running Linux™",
      "ReAX™ Core Engine",
      "QR Smart Room Logging and Scheduling",
      "1GB DDR3",
      "8GB Storage",
      "2 RS-232",
      "2 IR",
      "2 Digital I/O",
      "2 Relay",
      "USB Type-C",
      "Ambient Light Sensor",
      "Proximity Sensor",
      "Speaker (1 Watt)",
      "Stereo Digital Microphones",
      "10/100 LAN PoE",
      "RGB LED Ring for Room Usage Status or Ambiance Lighting"
    ],
    specifications: [
      "Display: 4\" 480x480 Resolution",
      "Brightness: 420 nits",
      "Processor: Dual Core @ 1.0GHz",
      "Operating System: Linux™",
      "Memory: 1GB DDR3",
      "Storage: 8GB",
      "Communications: 10/100 LAN PoE (IEEE 802.3af)",
      "Control Ports: 2 RS-232, 2 IR, 2 Digital I/O, 2 Relay",
      "I/O: USB Type-C (Host, USB 2.0)",
      "Sensors: Ambient Light Sensor, Proximity Sensor",
      "Audio: Speaker (1 Watt), Stereo Digital Microphones",
      "Status: RGB LED Ring for Room Usage Status or Ambiance Lighting",
      "Mounting: In-Wall (RXT-4-WM), Table Top (RXT-4-TT), Glass Mount (RXT-4-GM)",
      "Dimensions (HxWxD): 91mm x 91mm x 13mm (3.58\" x 3.58\" x 0.51\")",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE (IEEE 802.3af)"
    ],
    images: [
      "/lovable-uploads/75c1026c-5af9-4a5a-b549-c8c4379eab9a.png",
      "/lovable-uploads/5f0279d0-ad60-4464-b3fd-985bc6c4ca9a.png"
    ],
    image: "/lovable-uploads/75c1026c-5af9-4a5a-b549-c8c4379eab9a.png",
    slug: "rxt-4-wm"
  },
  {
    id: "rxt-8-wm",
    groupId: "reax-touch-controllers",
    name: "RXT-8-WM",
    description: "About\nThe RXT-8 is a versatile 8\" ReAX™ JavaScript based Touch Panel/Control System. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-8 has a beautiful 1280 x 800 16:10 aspect ratio touch screen with a wide viewing angle and a room status lighting strip for enhanced visual indication of room availability. It supports 1080p 60fps H.264 video decoding, WiFi/BT, multiple control ports (RS-232, IR, I/O, relay), stereo digital microphones, a high-quality speaker, ambient light sensor, proximity sensor, and a camera.\n\nThe sleek wall-mounted RXT-8-WM is available and can be installed using a standard 2-gang US electrical box, 2-gang EU/UK electrical box, or our optional RXT-8-BBK for drywall installation. The RXT-8 provides a powerful and elegant solution for your presentation, automation, and meeting room scheduling needs.\n\nCore Studio tool is available free of charge for code and interface creation.",
    features: [
      "8\" 1280x800 Resolution",
      "400 nits",
      "Quad Core Processor running Linux™",
      "ReAX™ Core Engine",
      "QR Smart Room Logging and Scheduling",
      "2GB DDR3",
      "16GB Storage",
      "2 RS-232",
      "2 IR",
      "2 Digital I/O",
      "2 Relay",
      "USB Type-C",
      "Ambient Light Sensor",
      "Proximity Sensor",
      "5MP Camera (2592×1944)",
      "Speaker (2 Watt)",
      "Stereo Digital Microphones",
      "10/100 LAN PoE",
      "Wi-Fi 802.11ac & Bluetooth 4.2",
      "Room Status Light Bar"
    ],
    specifications: [
      "Display: 8\" IPS LCD with 16:10 Aspect Ratio",
      "Resolution: 1280 x 800",
      "Brightness: 400 nits",
      "Touch: Projected Capacitive Multi-Touch",
      "Processor: Quad Core @ 1.6GHz",
      "Memory: 2GB DDR3",
      "Storage: 16GB",
      "Camera: 5MP",
      "Network: 10/100 Ethernet with PoE (IEEE 802.3af/at)",
      "Wireless: Wi-Fi 802.11ac & Bluetooth 4.2",
      "Control Ports: 2 RS-232, 2 IR, 2 Digital I/O, 2 Relay",
      "USB: Type-C (Host/Device, USB 2.0)",
      "Video: H.264 Decode up to 1080p 60fps",
      "Sensors: Ambient Light Sensor, Proximity Sensor",
      "Audio: Speaker (2 Watt), Stereo Digital Microphones",
      "Status: RGB LED Light Bar",
      "Mounting: In-Wall using standard 2-gang US or EU/UK electrical box, or RXT-8-BBK (optional)",
      "Dimensions (HxWxD): 228mm x 148mm x 14mm (9\" x 5.83\" x 0.55\")",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE (IEEE 802.3af/at)"
    ],
    images: [
      "/lovable-uploads/1234ac3b-2b0d-4698-9458-bff822c0dce9.png",
      "/lovable-uploads/30982b77-dc1e-4256-b730-4081e890ae86.png"
    ],
    image: "/lovable-uploads/1234ac3b-2b0d-4698-9458-bff822c0dce9.png",
    slug: "rxt-8-wm"
  },
  {
    id: "rxt-8d",
    groupId: "reax-touch-controllers",
    name: "RXT-8D",
    description: "About\nThe RXT-8D is the World's first ReAX JavaScript based Touch Panel/Control System. Ideal for conference rooms, educational facilities, digital signage and more.\n\nDesigned to sit on any flat surface, the RXT-8D has a beautiful 1280 x 800 touch screen with 170-degree viewing and room status lighting. The 2D and 3D graphics engine with H.264 streaming decoder provides a powerful solution for complex graphics and video, ensuring an enhanced user experience. To further enhance the experience the RXT-8D has a 1-watt speaker system, and digital microphone for conferencing.\n\nThe RXT-8D is a powerful 'all in one' solution for your presentation and automation needs. Core Studio tool is available free of charge for code and interface creation.",
    features: [
      "1280x800 Resolution",
      "Six Core Processor",
      "2G RAM and 16G Flash",
      "ReAX Server running on Android 10",
      "Audio Decoder MP3/WMA/AAC",
      "Video Decoder 4K MPEG-1/2/4, H.263, H.264, H.265",
      "USB OTG, USB 2.0, USB Serial",
      "5M/P Front Camera",
      "WIFI 802.11b/g/n",
      "NFC",
      "SD Card Slot up to 32GB",
      "One 1-Watt Speakers",
      "PoE"
    ],
    specifications: [
      "System: Default Passcode - Last 8 numeric characters of units serial number",
      "CPU: Six core cortex A17",
      "RAM: 2GB",
      "Internal memory: 16GB",
      "Operating system: ReAX server running on Android 10.0",
      "Display: 8\" LCD",
      "Resolution: 1280x800",
      "Touch screen: 10-point capacitive touch",
      "Viewing angle: 170° (85/85/85/85 [L/R/U/D])",
      "Contrast ratio: 800:1",
      "Luminance: 250cd/m2",
      "Aspect ratio: 16:10",
      "WiFi: 802.11 b/g/n (EIRP <0.1mW)",
      "Ethernet: 10M/100M/1000M",
      "Card slot: TF (Micro-SD) card, up to 32GB",
      "RS-232: USB for serial (RS232 format)",
      "USB: USB Host 2.0",
      "USB Type-C: USB OTG Only",
      "Power jack: DC power input",
      "Audio out: 3.5mm TRS out",
      "Ethernet port: RJ-45",
      "NFC: 13.56MHz, ISO14443A/ISO14443B/ISO 15693/Mifare classic/Sony felica",
      "Microphone: Single microphone",
      "Speaker: (1) 2W speaker",
      "Camera: 5.0M/P front camera",
      "Power: 12V/1.5A or PoE",
      "Power adapter: 12V adapter included",
      "Product dimensions (WxHxD): 8.125\" x 4.125\" x 5.63\" (206.4mm x 104.8mm x 143mm)",
      "Weight: 1lb (0.45kg)",
      "Enclosure: Plastic enclosure, white or black",
      "Operating temperature: 0~40°C [32~104°F]",
      "Storage temperature: 0~60°C [32~140°F]",
      "Relative humidity: 20~85% RH [no condensation]"
    ],
    images: [
      "/lovable-uploads/5989435b-7c5d-4ed8-8112-22f92795f7b5.png",
      "/lovable-uploads/1104fd97-b60d-49e2-9e40-f61c45c8ed99.png",
      "/lovable-uploads/5f30d29d-9383-45d0-9795-f05313e57fd4.png"
    ],
    image: "/lovable-uploads/5989435b-7c5d-4ed8-8112-22f92795f7b5.png",
    slug: "rxt-8d"
  },
  {
    id: "rxt-10-vs",
    groupId: "reax-touch-controllers",
    name: "RXT-10-VS",
    description: "About\nThe RXT-10-VS is a powerful 10\" ReAX™ JavaScript based Touch Panel/Control System with integrated video preview. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-10-VS has a beautiful 1920 x 1200 16:10 aspect ratio touch screen with projected capacitive touch technology and a wide viewing angle, making it perfect for meeting rooms and presentation spaces.\n\nThe RXT-10-VS supports 1080p 60fps H.264 video decoding, and offers comprehensive connectivity options including USB-C, HDMI Out, USB 3.0, LAN, SD Card slot, and Audio Line Out. With its sleek wall-mounted design and black glass bezel, the RXT-10-VS provides an elegant and powerful solution for your AV control and automation needs.\n\nPowered by the ReAX Core Engine, this panel offers JavaScript-based control capabilities that can be customized using the free Core Studio tool for flexible interface creation.",
    features: [
      "10\" 1920x1200 Resolution",
      "350 nits Brightness",
      "Quad Core Processor running Linux™",
      "ReAX™ Core Engine",
      "JavaScript-based Control",
      "Video Preview Capability",
      "8GB DDR4 RAM",
      "32GB Storage",
      "USB-C Port",
      "HDMI Output",
      "USB 3.0 Port",
      "SD Card Slot",
      "Audio Line Out",
      "LAN with PoE",
      "Reset Button",
      "Wall Mount Design",
      "Black Glass Bezel",
      "Multi-Touch Support",
      "Real-time Video Preview"
    ],
    specifications: [
      "Display: 10\" IPS LCD with 16:10 Aspect Ratio",
      "Resolution: 1920 x 1200",
      "Brightness: 350 nits",
      "Touch: Projected Capacitive Multi-Touch",
      "Processor: Quad Core @ 2.0GHz",
      "Memory: 8GB DDR4",
      "Storage: 32GB eMMC",
      "Graphics: Integrated GPU",
      "Video Output: HDMI Out",
      "Network: Gigabit Ethernet with PoE (IEEE 802.3af/at)",
      "USB Ports: USB-C, USB 3.0",
      "Audio: Audio Line Out",
      "Storage Expansion: SD Card Slot",
      "Power Input: 12V DC (adapter included)",
      "Mounting: Wall Mount",
      "Dimensions: 10.5\" x 7.4\" x 1.9\"",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE (IEEE 802.3af/at)"
    ],
    images: [
      "/lovable-uploads/b4175850-ef3f-43e3-a210-b4860d38659c.png",
      "/lovable-uploads/168c9217-0660-4d89-9246-9060c51270fa.png"
    ],
    image: "/lovable-uploads/b4175850-ef3f-43e3-a210-b4860d38659c.png",
    slug: "rxt-10-vs"
  },
  {
    id: "rxt-10d",
    groupId: "reax-touch-controllers",
    name: "RXT-10D",
    description: "About\nThe RXT-10D is a powerful 10\" ReAX™ JavaScript based Touch Panel/Control System in a sleek desktop form factor. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-10D has a beautiful 1280 x 800 16:10 aspect ratio touch screen with projected capacitive touch technology and a wide viewing angle, making it perfect for desktop control applications.\n\nThe RXT-10D supports 1080p 60fps H.264 video decoding and offers comprehensive connectivity options including USB-C, USB 3.0, and LAN. With its elegant desktop design and adjustable viewing angle, the RXT-10D provides an ideal solution for your AV control and automation needs.\n\nPowered by the ReAX Core Engine, this panel offers JavaScript-based control capabilities that can be customized using the free Core Studio tool for flexible interface creation.",
    features: [
      "10\" 1280x800 Resolution",
      "400 nits Brightness",
      "Quad Core Processor running Linux™",
      "ReAX™ Core Engine",
      "JavaScript-based Control",
      "Video Preview Capability",
      "2GB DDR3 RAM",
      "16GB Storage",
      "USB-C Port",
      "4x USB 3.0 Ports",
      "LAN with PoE",
      "Desktop Form Factor",
      "Adjustable Viewing Angle",
      "Built-in Stereo Speakers",
      "Multi-Touch Support",
      "Real-time Video Preview",
      "QR Smart Room Logging and Scheduling"
    ],
    specifications: [
      "Display: 10\" IPS LCD with 16:10 Aspect Ratio",
      "Resolution: 1280 x 800",
      "Brightness: 400 nits",
      "Touch: Projected Capacitive Multi-Touch",
      "Processor: Quad Core @ 1.6GHz",
      "Memory: 2GB DDR3",
      "Storage: 16GB eMMC",
      "Graphics: Integrated GPU with H.264 1080p Decode",
      "Network: 10/100 Ethernet with PoE (IEEE 802.3af/at)",
      "USB Ports: 1x USB-C, 4x USB 3.0",
      "Audio: Built-in Stereo Speakers",
      "Stand: Adjustable Desktop Mount",
      "Dimensions (HxWxD): 173mm x 261mm x 129mm (6.8\" x 10.3\" x 5.1\")",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE (IEEE 802.3af/at)"
    ],
    images: [
      "/lovable-uploads/892f7ff8-9cc4-4c1e-8f06-9b55c2555adc.png",
      "/lovable-uploads/a9cbf2b4-3360-4122-a0a4-70dc49dfb91d.png",
      "/lovable-uploads/923b1665-bd0d-41b1-ae77-8fb521b734c1.png"
    ],
    image: "/lovable-uploads/892f7ff8-9cc4-4c1e-8f06-9b55c2555adc.png",
    slug: "rxt-10d"
  },
  {
    id: "rxt-15-vs",
    groupId: "reax-touch-controllers",
    name: "RXT-15-VS",
    description: "About\nThe RXT-15-VS is a powerful 15.6\" ReAX™ JavaScript based Touch Panel/Control System with integrated video preview. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-15-VS features a beautiful 1920 x 1080 Full HD display with projected capacitive touch technology, providing an immersive control experience for larger spaces.\n\nThe RXT-15-VS offers comprehensive connectivity options including USB-C, HDMI Out, USB 3.0, LAN, SD Card slot, and Audio Line Out, making it capable of interfacing with a wide variety of AV equipment. With its sleek wall-mounted design and black glass bezel, the RXT-15-VS provides an elegant and powerful solution for sophisticated control environments.\n\nPowered by the ReAX Core Engine, this panel offers JavaScript-based control capabilities that can be customized using the free Core Studio tool for flexible interface creation and integration with other systems.",
    features: [
      "15.6\" 1920x1080 Full HD Resolution",
      "350 nits Brightness",
      "Quad Core Processor running Linux™",
      "ReAX™ Core Engine",
      "JavaScript-based Control",
      "Video Preview Capability",
      "8GB DDR4 RAM",
      "32GB Storage",
      "USB-C Port",
      "HDMI Output",
      "USB 3.0 Port",
      "SD Card Slot",
      "Audio Line Out",
      "LAN with PoE+",
      "Reset Button",
      "Wall Mount Design",
      "Black Glass Bezel",
      "Multi-Touch Support",
      "Real-time Video Preview",
      "Custom Interface Support"
    ],
    specifications: [
      "Display: 15.6\" IPS LCD",
      "Resolution: 1920 x 1080 (Full HD)",
      "Brightness: 350 nits",
      "Touch: Projected Capacitive Multi-Touch",
      "Processor: Quad Core @ 2.0GHz",
      "Memory: 8GB DDR4",
      "Storage: 32GB eMMC",
      "Graphics: Integrated GPU",
      "Video Output: HDMI Out",
      "Network: Gigabit Ethernet with PoE+ (IEEE 802.3at)",
      "USB Ports: USB-C, USB 3.0",
      "Audio: Audio Line Out",
      "Storage Expansion: SD Card Slot",
      "Power Input: 12V DC (adapter included)",
      "Mounting: Wall Mount",
      "Dimensions: 15.7\" x 10.5\" x 2.1\"",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE+ or 12V DC"
    ],
    images: [
      "/lovable-uploads/34c2da2a-295c-49f1-88f1-61170f8304c3.png",
      "/lovable-uploads/8473b96e-ee16-40a6-bd1c-9acd9fcdb304.png"
    ],
    image: "/lovable-uploads/34c2da2a-295c-49f1-88f1-61170f8304c3.png",
    slug: "rxt-15-vs"
  },
  {
    id: "rxt-21-vs",
    groupId: "reax-touch-controllers",
    name: "RXT-21-VS",
    description: "About\nThe RXT-21-VS is a powerful 21.5\" ReAX™ JavaScript based Touch Panel/Control System with integrated video preview. Ideal for conference rooms, educational facilities, hospitality, digital signage and more. The RXT-21-VS features a beautiful 1920 x 1080 Full HD display with projected capacitive touch technology, providing an immersive control experience for larger venues and sophisticated control environments.\n\nThe RXT-21-VS offers comprehensive connectivity options including USB-C, HDMI Out, USB 3.0, LAN, SD Card slot, and Audio Line Out, making it capable of interfacing with a wide variety of AV equipment. With its sleek wall-mounted design and black glass bezel, the RXT-21-VS provides an elegant and powerful solution for sophisticated control environments.\n\nPowered by the ReAX Core Engine, this panel offers JavaScript-based control capabilities that can be customized using the free Core Studio tool for flexible interface creation, digital signage, and integration with other systems.",
    features: [
      "21.5\" 1920x1080 Full HD Resolution",
      "350 nits Brightness",
      "Quad Core Processor running Linux™",
      "ReAX™ Core Engine",
      "JavaScript-based Control",
      "Video Preview Capability",
      "8GB DDR4 RAM",
      "32GB Storage",
      "USB-C Port",
      "HDMI Output",
      "USB 3.0 Port",
      "SD Card Slot",
      "Audio Line Out",
      "Gigabit LAN with PoE+",
      "Reset Button",
      "Wall Mount Design",
      "Black Glass Bezel",
      "Multi-Touch Support",
      "Real-time Video Preview",
      "Custom Interface Support",
      "Digital Signage Capability",
      "Room Layout Controls"
    ],
    specifications: [
      "Display: 21.5\" IPS LCD",
      "Resolution: 1920 x 1080 (Full HD)",
      "Brightness: 350 nits",
      "Touch: Projected Capacitive Multi-Touch",
      "Processor: Quad Core @ 2.0GHz",
      "Memory: 8GB DDR4",
      "Storage: 32GB eMMC",
      "Graphics: Integrated GPU",
      "Video Output: HDMI Out",
      "Network: Gigabit Ethernet with PoE+ (IEEE 802.3at)",
      "USB Ports: USB-C, USB 3.0",
      "Audio: Audio Line Out",
      "Storage Expansion: SD Card Slot",
      "Power Input: 12V DC (adapter included)",
      "Mounting: Wall Mount",
      "Dimensions: 20.5\" x 13.2\" x 2.0\"",
      "Operating Temperature: 0°C to +40°C (32°F to 104°F)",
      "Operating Humidity: 10% to 90% RH (non-condensing)",
      "Power Supply: PoE+ or 12V DC"
    ],
    images: [
      "/lovable-uploads/2f573faf-1ba2-4184-9fbd-84ac678fd442.png",
      "/lovable-uploads/ab132973-4642-4950-8af8-6542934e1276.png"
    ],
    image: "/lovable-uploads/2f573faf-1ba2-4184-9fbd-84ac678fd442.png",
    slug: "rxt-21-vs"
  }
];
